<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        show-footer
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
        :footer-method="footerMethod"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/equipmentMortgage.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import { filterEmpty, toLine } from '@/common/js/util';
  // import { dateFormatter } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  import XEUtils from 'xe-utils';
  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'equipmentMortgageList',
    data() {
      return {
        exportAction: API.EXPORT_EQUIPMENT_MORTGAGE_API,
        load: false,
        companyList: [], //公司列表
        query: {
          businessCompanyCode: '', //公司
          equipmentName: '', //机器名称
          customerCode: '',
          debtMaturityBegin: '',
          debtMaturityEnd: '',
          mortgageStatus: '',
        },

        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        partnerTypeList: [], //合作伙伴类型
        partnerTypeData: [],
        creditTypeList: [], //授信类型下拉列表
        creditTypeData: [],
        accountsTypeData: [],
        enterprisePropertyData: [],
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'mortgageStatus',
            title: '状态',
            width: '100',
            visible: true,
            type: 'dict',
            dictType: 'mortgage_status',
          },
          {
            field: 'businessCompanyName',
            title: '公司',
            width: '180',
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户',
            width: '180',
            visible: true,
          },
          { field: 'equipmentType', title: '设备种类', visible: true },
          {
            field: 'detailCreditAmount',
            title: '授信评估金额',
            format: 'formatAmountRound',
            visible: true,
          },
          { field: 'equipmentSpec', title: '规格', visible: true },
          { field: 'equipmentSupplier', title: '设备供应商', visible: true },
          { field: 'equipmentNo', title: '设备编号', visible: true },
          { field: 'purchaseYear', title: '购置年份', visible: true },
          { field: 'invoiceNo', title: '发票号码', visible: true },
          {
            field: 'invoiceAmount',
            title: '发票金额（含税）',
            format: 'formatAmountRound',
            visible: true,
          },
        ],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            //状态
            type: 'dict',
            prop: 'mortgageStatus',
            name: '状态',
            // apiUrl: AGENCY_API.DICT_LIST,
            dictType: 'mortgage_status',
            placeholder: '请选择状态',
            clearable: true,
          },
          {
            //公司
            type: 'select',
            name: '公司',
            prop: 'businessCompanyCode',
            placeholder: '请选择公司',
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            // 客户
            type: 'searchTableSpec',
            prop: 'customerCode',
            isMultiple: true,
            name: '客户',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              requestStatus: 'ZT03',
              adminFlag: this.userInfo.adminFlag,
              // department:this.userInfo.department,
              company: this.query.businessCompanyCode,
            },
            // currentValue: this.baseData.partnerNo,
            // span: 12,
          },
          {
            //机器名称
            prop: 'equipmentName',
            name: '机器名称',
            type: 'input',
            clearabled: true,
            placeholder: '请输入机器名称',
          },
          {
            //抵押期限开始
            prop: 'debtMaturityBegin',
            name: '设备期限（起）',
            placeholder: '请选择设备期限',
            type: 'startDaterangePicker',
          },
          {
            //抵押期限结束
            prop: 'debtMaturityEnd',
            name: '设备期限（止）',
            placeholder: '请选择设备期限',
            type: 'endDaterangePicker',
          },
        ];
      },
      ...mapState({}),
    },
    /**页面必要代码Start */
    mounted() {
      this.getButtonList();
      this.getData();
      this.getCompany();
    },
    methods: {
      errorTip(message) {
        this.$message({ showClose: true, message, type: 'error' });
      },
      footerMethod({ columns, data }) {
        let returnProps = ['detailCreditAmount'];
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (returnProps.includes(column.property)) {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 2);
            }
            return null;
          }),
        ];
      },
      // 查询参数整理
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        const query = { ...this.query, pageSize, pageNum };
        if (query.customerCode && query.customerCode.length > 0) {
          const { partnerCode } = query.customerCode[0];
          query.customerCode = partnerCode;
        }

        return query;
      },
      // 加载公司列表
      async getCompany() {
        const selectStatus = await this.$axios.get(
          DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.setSearchParams();
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.EQUIPMENT_MORTGAGE_LIST_API, query).then((res) => {
          this.load = false;
          console.log(res);
          if (0 == res.data.code) {
            console.log(res.data);
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/credit/equipmentMortgageEdit',
          name: 'equipmentMortgageEdit',
          meta: {
            keepAlive: true,
            title: '设备抵押申请单详情',
          },
          query: {
            id: e.row.id,
            isEdit: 'N',
          },
        };
        console.log(e.row.id);
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'export') {
          //导出
          // let params = this.setSearchParams();
          this.commonExport();
        } else if (type === 'edit') {
          if (this.multipleSelection.length == 0) {
            this.$message({
              showClose: true,
              message: '您还没选择要修改的数据',
              type: 'error',
            });
          } else if (this.multipleSelection.length > 1) {
            this.$message({
              showClose: true,
              message: '一次只能修改一条数据',
              type: 'error',
            });
          } else {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            let path = {
              path: '/credit/equipmentMortgageEdit',
              name: 'equipmentMortgageEdit',
              meta: {
                keepAlive: true,
                title: '设备抵押申请单修改',
              },
              query: {
                id: ids,
                isEdit: 'N',
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
      },
      //新增
      add() {
        let path = {
          path: '/credit/equipmentMortgageAdd',
          name: 'equipmentMortgageAdd',
          meta: {
            keepAlive: true,
            title: '设备抵押申请单新增',
          },
          query: {
            isEdit: 'Y',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //删除
      del() {
        const deleteStatus = ['saved', 'rejected'];
        const contractStatus = this.multipleSelection.some((item) => {
          console.log(item);
          return !deleteStatus.includes(item.mortgageStatus);
        });
        console.log(contractStatus);
        if (contractStatus) {
          this.errorTip('只有已保存、已驳回状态可删除');
          return;
        }
        this.$confirmAction()
          .then(() => {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            this.$axios.post(API.DELETE_EQUIPMENT_MORTGAGE_API, { ids }).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      /**页面必要代码End */
    },
  };
</script>
